import { ReplyContentType } from "./CommentTypes";
import { ImageSolidIcon } from "@icons/ImageSolidIcon";
import { LinkoutReply } from "./LinkoutReply";
import {
    CommentReplyTextContainerGrid,
    CommentReplyTextParagraph,
    CommentReplyUserNameTypography,
} from "../Modals/CommentFormModal/CommentFormModal.styles";
import { getUserName } from "@shared/UserHelpers";
import React from "react";

export function CommentInputReply({
    replyComment,
}: {
    replyComment: ReplyContentType;
}) {
    if (!replyComment || !replyComment.user) {
        return <></>;
    }

    let replyText = replyComment?.text
        ? replyComment.text.length > 55
            ? replyComment.text.slice(0, 56) + "..."
            : replyComment.text
        : undefined;

    if (replyText && replyComment?.images?.length) {
        replyText = "Bild";
    }

    const replyImage = replyComment?.images?.length ? (
        <>
            <ImageSolidIcon
                height={15}
                color="var(--community-color-secondary-text)"
                width={"unset"}
            />
            &nbsp;
        </>
    ) : undefined;

    const replyLinkout = replyComment?.linkoutUrl ? (
        <LinkoutReply linkoutUrl={replyComment.linkoutUrl} />
    ) : undefined;

    return (
        <CommentReplyTextContainerGrid>
            <CommentReplyUserNameTypography>
                Antwort an {getUserName(replyComment.user.screenName)}
            </CommentReplyUserNameTypography>
            <CommentReplyTextParagraph>
                {replyImage}
                {replyText}
                {replyLinkout}
            </CommentReplyTextParagraph>
        </CommentReplyTextContainerGrid>
    );
}
